import { upperFirst } from "lodash";
import { emailIsGood } from ".";

type Names = {
  firstName: string;
  lastName: string;
  companyName: string;
  companyWebsite: string;
};

export function extractNamesFromEmail(email: string): Names {
  const isEmailGood = emailIsGood(email);

  const names: Names = {
    firstName: "",
    lastName: "",
    companyName: "",
    companyWebsite: "http://"
  };

  if (!isEmailGood) {
    return names;
  }

  const [userNamesPart, companyNamePart] = email.split("@");

  names.companyName = companyNamePart!
    .split(".")
    .slice(0, -1)
    .map((name) => upperFirst(name))
    .join(" ");
  names.companyWebsite = "http://" + companyNamePart;

  const userNamesStrings = userNamesPart!.split(".").map((name) => upperFirst(name));
  if (userNamesStrings.length === 1) {
    names.firstName = userNamesStrings[0]!;
  } else {
    names.lastName = userNamesStrings.pop() || "";
    names.firstName = userNamesStrings.join(" ");
  }

  return names;
}
